import { TicketBackOfficeDetails } from './TicketBackOfficeDetails'

const TicketBackOfficeTabs = (): JSX.Element => <TicketBackOfficeDetails />

export default TicketBackOfficeTabs
